import { CHANNEL_OTP, TOtpRecipients } from './types';

export const mapOtpOptions = (otpRecipients: TOtpRecipients) =>
  otpRecipients?.map((o) => {
    if (o.channel === CHANNEL_OTP.EMAIL) {
      return {
        value: CHANNEL_OTP.EMAIL,
        icon: '/icon/password-email-small.svg',
        text: 'Send via Email',
        subText: o.target,
      };
    }
    if (o.channel === CHANNEL_OTP.WHATSAPP) {
      return {
        value: CHANNEL_OTP.WHATSAPP,
        icon: '/icon/password-whatsapp.svg',
        text: 'Send via Whatsapp',
        subText: o.target,
      };
    }
    if (o.channel === CHANNEL_OTP.SMS) {
      return {
        value: CHANNEL_OTP.SMS,
        icon: '/icon/password-message.svg',
        text: 'Send via SMS',
        subText: o.target,
      };
    }
    return {
      value: CHANNEL_OTP.EMAIL,
      icon: '/icon/password-email-small.svg',
      text: 'Send via Email',
      subText: o.target,
    };
  });

export const calculateRemainingOtpSecond = (dateTime) => {
  if (!dateTime) {
    return 0;
  }

  const givenTime = new Date(dateTime);
  const currentTime = new Date();
  const timeDifference = givenTime.getTime() - currentTime.getTime();
  const remainingSecond = Math.floor(timeDifference / 1000);

  return remainingSecond;
};
